import { create } from 'zustand';
import { auth, ApiError, type Me } from '../api/client';

type AuthState = {
  me: Me | null;
  loading: boolean;
  error: string | null;
  init: () => Promise<void>;
  login: (username: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
};

export const useAuth = create<AuthState>((set) => ({
  me: null,
  loading: true,
  error: null,
  async init() {
    try {
      const me = await auth.me();
      set({ me, loading: false, error: null });
    } catch {
      set({ me: null, loading: false, error: null });
    }
  },
  async login(username, password) {
    set({ loading: true, error: null });
    try {
      const me = await auth.login(username, password);
      set({ me, loading: false, error: null });
    } catch (e) {
      const msg = e instanceof ApiError ? e.message : 'Login fehlgeschlagen';
      set({ me: null, loading: false, error: msg });
      throw e;
    }
  },
  async logout() {
    await auth.logout().catch(() => {});
    set({ me: null });
  },
}));
